import { Component } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';

/**
 * Represents the basic layout of the application.
 * It is used for the main structure of the app. 95% of all pages will be based on this layout.
 * For correct content projection, please use the `lvr-basic-layout-header` and `lvr-basic-layout-left` components.
 *
 * Example usage:
 * ```html
 * <lvr-basic-layout>
 *  <lvr-basic-layout-header> Header Content </lvr-basic-layout-header>
 *  <lvr-basic-layout-left> Left Side Content </lvr-basic-layout-left>
 *  <p>Main Content</p>
 * </lvr-basic-layout>
 */
@Component({
	selector: 'lvr-basic-layout',
	imports: [ScrollingModule],
	templateUrl: './basic-layout.html',
	styleUrl: './basic-layout.scss',
})
export class BasicLayoutComponent {}
